import React, { useEffect, useReducer, useRef, useState } from 'react';
import getUserReviews from 'src/modules/parkplusStoreV2/services/pdp/getreviews';
import { PdpPropType } from 'src/modules/parkplusStoreV2/types/product';
import { Button } from 'ui-v2/components/Button';
import s from './Reviews.module.scss';
import ProductReview from 'src/modules/parkplusStoreV2/uiComponents/ProductReview';
import OverallRating from 'src/modules/parkplusStoreV2/uiComponents/OverallRating';
import AllReviewPopup from '../AllReviewPopup';
import {
  trackCtaClickedStoreV2,
  trackSectionViewedStoreV2,
} from 'src/modules/parkplusStoreV2/utils/events';
import { useComponentInViewport } from 'core-lib/hooks/useComponentInViewport';
import {
  UPDATE_HAS_MORE,
  UPDATE_LOADING,
  UPDATE_PAGE,
  UPDATE_RATING_DATA,
  UPDATE_REVIEW_DATA,
} from './action';
import Reviewreducer from './reducer';
import ImageView from 'src/modules/parkplusStoreV2/uiComponents/Popups/ImageView';
import checkIsProductBought from 'src/modules/parkplusStoreV2/services/pdp/checkIsProductBought';
import { customToast } from 'core-lib/utils/customToast';
import { useSelector } from 'react-redux';
import Icon from 'ui-v2/components/Icon/Icon';
import { Divider } from 'ui-v2/components/Divider';

export const Reviews = ({ data }: PdpPropType) => {
  //useReducer not an react redux hook rather a replacement of useState hook for complex state management
  const [state, dispatch] = useReducer(Reviewreducer, {
    reviewsData: [],
    ratingData: null,
    page: 1,
    loading: true,
    hasMore: false,
  });
  const [showAllReview, setShowAllReview] = useState(false);
  const [showImage, setShowImage] = useState(null);
  const [showAddReview, setShowAddReview] = useState(false);

  const rootRef = useRef();
  const isEventFired = useRef(false);
  const inViewPort = useComponentInViewport(rootRef, {
    threshold: 0.5,
  });

  const { isAuthenticated } = useSelector((state) => state.auth);

  const isProductBought = async () => {
    const { response, error } = await checkIsProductBought(data.productId);
    if (response) {
      if (response?.canReview) {
        setShowAddReview(true);
      }
    } else {
      customToast(error?.message || 'something went wrong');
    }
  };

  const fetchProductReviews = async () => {
    const limit = 10;
    dispatch({
      type: UPDATE_LOADING,
      loading: true,
    });
    const { response } = await getUserReviews(
      data?.productId,
      state.page,
      limit
    );
    if (response) {
      dispatch({
        type: UPDATE_REVIEW_DATA,
        reviewsData: response.reviewsData,
      });
      if (Number(response?.page) * limit < response.count) {
        dispatch({
          type: UPDATE_PAGE,
          page: state.page + 1,
        });
        dispatch({
          type: UPDATE_HAS_MORE,
          hasMore: true,
        });
      } else {
        dispatch({
          type: UPDATE_HAS_MORE,
          hasMore: false,
        });
      }
      dispatch({
        type: UPDATE_RATING_DATA,
        ratingData: response?.ratingsData,
      });
    }
    dispatch({
      type: UPDATE_LOADING,
      loading: false,
    });
  };
  useEffect(() => {
    fetchProductReviews();
    isAuthenticated && isProductBought();
  }, []);

  useEffect(() => {
    if (inViewPort && !isEventFired.current && state.ratingData?.avgRating) {
      trackSectionViewedStoreV2('review');
      isEventFired.current = true;
    }
  }, [inViewPort, state.ratingData?.avgRating]);

  return (
    <div className={s.root} ref={rootRef}>
      {(state.ratingData?.avgRating || showAddReview) && (
        <Divider variant="padded" />
      )}
      <OverallRating
        ratingData={state.ratingData}
        product={{
          imgUrl: data?.coverImage,
          title: data?.title,
          subtitle: data?.subtitle1,
          id: data?.productId,
          sku: data?.productSku,
        }}
        showAdd={showAddReview}
        hideAdd={() => setShowAddReview(false)}
      />
      {!!state.reviewsData?.length && (
        <>
          <ProductReview
            data={state.reviewsData[0]}
            showBorder={false}
            onImageClick={(item) => setShowImage(item)}
          />
          <Button
            style={{
              width: '100%',
              paddingTop: '16px',
              paddingBottom: '16px',
            }}
            rightIcon={<Icon name="ChevronRightRegular" width={20} height={20} />}
            label="Read all reviews"
            variant="link_color"
            size="medium"
            onClick={() => {
              setShowAllReview(true);
              trackCtaClickedStoreV2(null, 'Read all reviews');
            }}
          />
        </>
      )}

      <AllReviewPopup
        show={showAllReview}
        onClose={() => setShowAllReview(false)}
        state={state}
        loadMore={fetchProductReviews}
        onImageClick={(item) => setShowImage(item)}
      />
      <ImageView show={showImage} onClose={() => setShowImage(null)} />
    </div>
  );
};
